module.exports = __webpack_public_path__ + "img/pump-warning.114ffe97.svg";